import { CreateCampaignFlow } from "../components/products";
import { AppBar, Box, IconButton, Stack, Toolbar } from "@mui/material";
import { AppRoutes } from "../types/enums";
import { CustomLogo } from "../components/images/Logo";
import CloseIcon from "@mui/icons-material/Close";
import { useAppSelector, useReturnBackNavigation } from "../hooks";
import { HEADER_HEIGHT } from "../utils/constants";
import { ReuseModal } from "../components/ui";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { clearCreateFlowLocalStorage } from "../utils/clearCreateFlowLocalStorage";
import { selectPermissions } from "../features/permissionsSlice";

const CreateCampaignPage = () => {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isCreateFlowStart, setIsCreateFlowStart] = useState<boolean>(false);
  const [isReturnBack, setIsReturnBack] = useState<boolean>(false);
  const { isAllowedEditCreateNewCampaign } = useAppSelector(selectPermissions);

  const { handleReturn } = useReturnBackNavigation(AppRoutes.CAMPAIGNS);

  const andProcessHandler = () => {
    clearCreateFlowLocalStorage();
    if (isReturnBack) {
      handleReturn();
    } else {
      navigate(AppRoutes.CAMPAIGNS);
    }
  };

  const returnBackHandler = () => {
    setIsReturnBack(true);
    onCloseHandler();
  };

  const onCloseHandler = () => {
    if (isCreateFlowStart) setIsOpen(true);
    else andProcessHandler();
  };

  if (!isAllowedEditCreateNewCampaign)
    return <Navigate to={AppRoutes.CAMPAIGNS} />;

  return (
    <Box paddingTop={HEADER_HEIGHT}>
      <AppBar
        color="default"
        sx={{
          position: "fixed",
          height: "74px",
          backgroundColor: "white",
          boxShadow: "none",
          px: { xs: 2, sm: 4, md: 5, xl: 9 },
          justifyContent: "center",
        }}
      >
        <Toolbar style={{ padding: 0, justifyContent: "space-between" }}>
          <Box sx={{ cursor: "pointer" }} onClick={onCloseHandler}>
            <CustomLogo />
          </Box>
          <IconButton
            onClick={returnBackHandler}
            size="small"
            sx={{ ml: "auto", color: "#828282" }}
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Stack
        sx={{ px: { xs: 2, sm: 8, md: 8, lg: 10, xl: 20 }, pt: 4, pb: 6 }}
        gap={3}
      >
        <CreateCampaignFlow
          setIsCreateFlowStart={setIsCreateFlowStart}
          returnBackHandler={returnBackHandler}
        />
      </Stack>
      <ReuseModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Do You Really Want to End the Process?"
        maxWidth="430px"
        maxTitleWidth="300px"
        submitBtnText="Yes"
        submitBtnColor="#C0392B"
        onSubmit={andProcessHandler}
        text="The changes won't be saved."
      />
    </Box>
  );
};

export default CreateCampaignPage;
